import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function WhyThisWorksSection() {
  const problems = ['Empezaste mil veces y dejaste a la semana', 'El cardio te destroza las rodillas y la espalda', 'Dietas que te dejaron con más ansiedad que antes', 'Rutinas de YouTube sin orden y sin resultados', 'Sentís que tu cuerpo ya no responde como antes', 'Cada lunes empezás de cero con culpa'];
  const solutions = [{
    title: 'Sin impacto',
    desc: 'Protege tus articulaciones.'
  }, {
    title: '20 min por día',
    desc: 'Rutinas cortas que podés sostener.'
  }, {
    title: 'Tonifica de verdad',
    desc: 'Tensión muscular constante.'
  }, {
    title: 'Reduce inflamación',
    desc: 'Liviana desde la semana 1.'
  }, {
    title: 'Sin dietas extremas',
    desc: 'Comés rico y variado.'
  }, {
    title: 'Videos paso a paso',
    desc: 'Sin experiencia previa.'
  }];
  return <section className="py-10 bg-white" data-id="element-266">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-267">
        <div className="text-center mb-6" data-id="element-268">
          <h2 className="font-display text-2xl md:text-4xl text-gray-900 mb-2" data-id="element-269">
            ¿Por qué los otros métodos no funcionaron?
          </h2>
          <p className="text-gray-500 text-sm max-w-xl mx-auto" data-id="element-270">
            No era falta de voluntad. Era el método equivocado.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto" data-id="element-271">
          <div className="bg-rose-50 rounded-2xl p-5 border border-rose-100" data-id="element-272">
            <h3 className="text-sm font-bold text-rose-900 mb-3" data-id="element-273">Lo que venías haciendo</h3>
            <div className="space-y-2" data-id="element-274">
              {problems.map((p, i) => <div key={i} className="flex items-start gap-2" data-id="element-275">
                  <XIcon className="w-3.5 h-3.5 text-rose-400 flex-shrink-0 mt-0.5" data-id="element-276" />
                  <p className="text-gray-700 text-xs" data-id="element-277">{p}</p>
                </div>)}
            </div>
          </div>

          <div className="bg-emerald-50 rounded-2xl p-5 border border-emerald-100" data-id="element-278">
            <h3 className="text-sm font-bold text-emerald-900 mb-3" data-id="element-279">El Método Wall Pilates</h3>
            <div className="space-y-2" data-id="element-280">
              {solutions.map((s, i) => <div key={i} className="flex items-start gap-2" data-id="element-281">
                  <CheckIcon className="w-3.5 h-3.5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-282" />
                  <p className="text-gray-700 text-xs" data-id="element-283">
                    <span className="font-bold" data-id="element-284">{s.title}:</span> {s.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}